import { useDispatch, useSelector } from 'react-redux';
import { createTpsTokenSelector, createTpsStatusSelector } from 'store/authentication/selectors';
import { useEffect, useState } from 'react';
import { fetchTokenForSource } from 'store/authentication/actions';
import { TpsSource } from 'store/authentication/tpsHelpers';

export const useTpsToken = (source: TpsSource) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(createTpsStatusSelector(source));
  const token = useSelector(createTpsTokenSelector(source));

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isAuthenticated) {
      setLoading(true);

      dispatch(fetchTokenForSource(source)).then(() => {
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, source, dispatch]);

  return { loading, token };
};
